import { getCookie, setCookie } from './cookies.js';

export function handleCookieBar(){
    const cookieName = "cookiesAccepted";
    const $cookieBar = $("#cookieBar");

    if (!getCookie(cookieName)) {
        $cookieBar.removeClass('d-none');
    }

    // Handle accept button click
    $("#acceptCookies").click(function () {
        setCookie(cookieName, "true", 365);
        $cookieBar.addClass('d-none');
    });
}
